module.exports = ".editButton{cursor:pointer}"